import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertJpgToIco() {
  return <ImageConverterTemplate sourceFormat="JPG" targetFormat="ICO" acceptTypes=".jpg,.jpeg,image/jpeg" slug="convert-jpg-to-ico" gradientColors="from-violet-500 to-purple-600" accentColor="purple" />;
}
